<template>
  <div
    class="yhc-ef-kazai-detail-input--select-kazai-options-list-item card yhc-sub-card"
  >
    <div
      class="yhc-ef-kazai-detail-input--select-kazai-options-list-item--title card-header"
    >
      <!--      <ficon type="plus-circle" class="_mr-1 text-muted"/>-->
      {{ serviceOption.description }}
      <span class="yhc-card-header--notice">※表示価格は全て税込です。</span>
    </div>
    <div
      class="yhc-ef-kazai-detail-input--select-kazai-options-list-item--options-wrap card-body"
    >
      <div
        v-if="serviceOption.notice"
        class="yhc-ef-kazai-detail-input--select-kazai-options-list-item--options-notice"
      >
        <YhcPublicWebHtmlContentDisplay
          class="yhc-ef-kazai-detail-input--select-kazai-options-list-item--options-notice--body yhc-richtext-content"
          :html-content="serviceOption.notice"
        />
      </div>
      <div
        class="yhc-ef-kazai-detail-input--select-kazai-options-list-item--options-wrap--inner"
      >
        <div
          class="yhc-ef-kazai-detail-input--select-kazai-options-list-item--option yhc-option-item"
          v-for="(option, index) in serviceOption.selections"
          :key="option.title"
          :class="selectedOptionsByTitle[option.title] ? 'selected' : ''"
          @click.prevent="() => toggleOptionSelectState(option)"
        >
          <span
            class="yhc-ef-kazai-detail-input--select-kazai-options-list-item--option--icon"
          >
            <ficon
              :type="
                optionIconsByState[
                  selectedOptionsByTitle[option.title] ? 'selected' : 'unselected'
                ]
              "
            />
          </span>
          {{ option.title }}
          <span
            class="yhc-ef-kazai-detail-input--select-kazai-options-list-item--option--price"
            >(+¥{{ option.price.toLocaleString() }})</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.yhc-ef-kazai-detail-input--select-kazai-options-list-item {
  .yhc-ef-kazai-detail-input--select-kazai-options-list-item--options-notice {
    font-size: 0.9em;
    margin-bottom: 0.5em;
  }
  .yhc-ef-kazai-detail-input--select-kazai-options-list-item--options-wrap--inner {
    display: flex;
    flex-wrap: wrap;
    gap: var(--yhc-base-pad-sm);
    .yhc-ef-kazai-detail-input--select-kazai-options-list-item--option {
      .yhc-ef-kazai-detail-input--select-kazai-options-list-item--option--icon {
        opacity: 0.3;
      }
      .yhc-ef-kazai-detail-input--select-kazai-options-list-item--option--price {
        font-size: 0.8em;
        //text-align: center;
        font-weight: normal;
        margin-top: 0.3em;
      }
    }
  }
}
</style>

<script lang="ts">
import { PropType } from 'vue'
import {
  ModelKazaiOptionServices,
  ModelKazaiOptionServicesOneSelection,
  ModelYhcKazaiTypesFullRelation,
} from '../../../../fireModels/yhcDataTypes'
import { optionIconsByStateAndType } from '../../formUtils'

export default {
  props: {
    kazaiType: {
      type: Object as PropType<ModelYhcKazaiTypesFullRelation>,
      required: true,
    },
    serviceOption: {
      type: Object as PropType<ModelKazaiOptionServices>,
      required: true,
    },
    selectedOptions: {
      type: Object as PropType<ModelKazaiOptionServicesOneSelection[]>,
      required: true,
    },
  },
  emits: ['updateSelectedOptions'],
  computed: {
    selectedOptionsByTitle(): {
      [title: string]: true
    } {
      return this.selectedOptions?.reduce((acc, s) => {
        acc[s.title] = true
        return acc
      }, {})
    },
    isMultipleSelection(): boolean {
      return this.serviceOption.selectionType !== true
    },
    optionIconsByState(): {
      selected: any
      unselected: any
    } {
      return optionIconsByStateAndType[this.isMultipleSelection ? 'multiple' : 'single']
    },
  },
  methods: {
    toggleOptionSelectState(addedOptionSelection: ModelKazaiOptionServicesOneSelection) {
      // ここで、択一式かどうかを判別して、択一式の場合は、1つだけ emit する
      if (!this.isMultipleSelection) {
        this.$emit('updateSelectedOptions', [addedOptionSelection])
        return
      }
      // 複数選択である場合には...
      // 追加 or 削除
      const isSelected = this.selectedOptionsByTitle[addedOptionSelection.title]
      if (isSelected) {
        this.$emit(
          'updateSelectedOptions',
          this.selectedOptions.filter((s) => s.title !== addedOptionSelection.title),
        )
      } else {
        this.$emit('updateSelectedOptions', [
          ...this.selectedOptions,
          addedOptionSelection,
        ])
      }
    },
  },
}
</script>
